export const moduleConfig = {
    basePath: '/billable-units',
    entityKey: 'billable-units',
    titles: {
        singular: 'Billable Unit',
        plural: 'Billable Units'
    }
}
